<template>
	<div class="mb-5">
		<v-card
			:ripple="false"
			color="white"
			flat
			tile
			:height="!$vuetify.breakpoint.mdAndDown ? '450' : '580'"
			:min-height="!$vuetify.breakpoint.mdAndDown ? '350' : '480'"
			:max-width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
			:width="!$vuetify.breakpoint.mdAndDown ? '80%' : '100%'"
		>
			<v-img height="210" :src="offer.image">
				<div class="fill-height bottom-gradient"></div>
			</v-img>

			<v-card
				flat
				color="transparent"
				min-height="150"
				class="py-4 text-left overflow-hidden"
			>
				<div class="text-h5 font-weight-bold black--text">{{ offer.name }}</div>
				<div class="grey--text pb-1 lighten-2 text-h6">{{ offer.address }}</div>
				<div
					class="grey--text pb-1 lighten-2 text-body-1 text-capitalize"
					v-if="isOnboarding"
				>
					{{ offer.type }}
				</div>
				<div class="price--text text-h5 font-weight-bold">
					<span class="text-body-1">Starting at</span>
					{{ formatMoney(startsAt) }}
				</div>
			</v-card>

			<div class="d-flex justify-start pb-8">
				<v-btn
					@click="paymentDialog = true"
					depressed
					:disabled="!offer.status"
					tile
					color="secondary"
					class="text-none px-5 py-5 mr-3 text-h6"
					>{{ offer.status ? "Buy" : "Sold Out" }}</v-btn
				>
				<v-btn
					@click="toggleHomesDrawer"
					tile
					depressed
					outlined
					color="primary"
					class="text-none px-5 py-5 text-h6"
					>About</v-btn
				>
			</div>
		</v-card>
		<homes-dialog
			@openPaystack="paystackOpen"
			:paymentDialog="paymentDialog"
			:toggleHomeDialog="togglePaymentMethodDialog"
			:home="offer"
			:isOnboarding="isOnboarding"
		/>
		<hm-paystack
			:isOpen="isPaystackOpen"
			:paystackCallback="paystackCallback"
			:paystackClose="paystackClose"
			:totalAmount="totalAmount"
			:paymentChannel="selectedPaymentMethod"
			:reference="reference"
		/>
	</div>
</template>

<script>
	import { formatMoney } from "@/utils/helpers";
	import HomesDialog from "./HomesDialog";
	import HmPaystack from "./../HmPaystack";
	import { TransactionService } from "@/services/index.js";

	export default {
		props: {
			offer: Object,
			isOnboarding: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			HomesDialog,
			HmPaystack,
		},
		data() {
			return {
				formatMoney,
				drawer: null,
				paymentDialog: null,
				isPaystackOpen: false,
				totalAmount: 0,
				reference: "",
				selectedPackage: "",
				selectedPaymentMethod: "",
			};
		},
		computed: {
			startsAt() {
				let res = this.offer?.homevestpackages[0]?.initialdeposit
					? this.offer?.homevestpackages[0]?.initialdeposit
					: this.offer?.minimumdeposit;

				return res > 0 ? res : 1000000;
			},
		},
		methods: {
			toggleHomesDrawer() {
				this.$store.commit("toggleDrawer", {
					type: "homes",
					value: true,
					entity: this.offer,
				});
			},
			goToOfferPage() {
				if (this.isOnboarding) {
					this.$router.push({
						name: "onboarding.homes.details",
						params: {
							id: this.offer.id,
						},
					});
				}
			},
			togglePaymentMethodDialog(value) {
				// console.log(value);
				this.paymentDialog = value;
				// this.$store.commit("togglePaymentMethodDialog", value);
			},
			async paystackCallback(res) {
				const { reference } = res;

				try {
					const { message } = await TransactionService.verify(
						reference,
						this.selectedPackage.packageid,
						"houseownerships",
						this.selectedPackage.savecard,
						this.selectedPackage.units,
						0,
						this.selectedPackage.nextcharge,
						this.selectedPackage.locationid,
						this.selectedPackage.name
					);

					this.$store.dispatch("openSnackbar", {
						message,
					});
					this.isPaystackOpen = false;
				} catch (error) {}
			},
			paystackClose() {
				this.isPaystackOpen = false;
			},

			paystackOpen(form) {
				this.selectedPaymentMethod = form.channel;
				this.totalAmount = form.total;
				this.reference = form.reference;
				this.selectedPackage = form.package;
				this.isPaystackOpen = true;
			},
		},
	};
</script>
